export default function dealValidate(
  validate,
  type = "input",
  title = "",
  required = false
) {
  let validateList = [];
  if (required) {
    validateList.push({
      required: true,
      message: getReuqiredMessage(type, title),
    });
  }

  if (validate) {
    const dealMessage = (valid) => {
      if (!valid.message) {
        if (valid.required) {
          valid.message = getReuqiredMessage(type, title);
        } else {
          valid.message = getDefaultMessage(valid);
        }
      }
      validateList.push(valid);
    };
    if (Array.isArray(validate)) {
      validate.forEach(dealMessage);
    } else {
      dealMessage(validate);
    }
  }
  return validateList;
}

function getReuqiredMessage(type, title) {
  let message = "请输入" + title;
  if (
    [
      "select",
      "checkbox",
      "radio",
      "datePicker",
      "cascader",
      "timePicker",
    ].includes(type)
  ) {
    message = "请选择" + title;
  } else if (type === "upload") {
    message = "请添加文件";
  }
  return message;
}

const defaultMessage = {
  string(validate) {
    if (validate.min && validate.max) {
      return `请输入${validate.min}-${validate.max}个字符`;
    } else if (validate.min) {
      return `请至少输入${validate.min}个字符`;
    } else if (validate.max) {
      return `请最多输入${validate.max}个字符`;
    }
  },
  integer(validate) {
    if (validate.min && validate.max) {
      return `请输入${validate.min}-${validate.max}之间的整数`;
    } else if (validate.min) {
      return `请输入最小是${validate.min}的整数`;
    } else if (validate.max) {
      return `请输入最大是${validate.max}的整数`;
    }
  },
  float(validate) {
    if (validate.min && validate.max) {
      return `请输入${validate.min}-${validate.max}之间的小数`;
    } else if (validate.min) {
      return `请输入最小是${validate.min}的小数`;
    } else if (validate.max) {
      return `请输入最大是${validate.max}的小数`;
    }
  },
  array(validate) {
    if (validate.min && validate.max) {
      return `请选择${validate.min}-${validate.max}个`;
    } else if (validate.min) {
      return `请最少选择${validate.min}个`;
    } else if (validate.max) {
      return `请最多选择${validate.max}个`;
    }
  },
};

function getDefaultMessage(validate) {
  return defaultMessage[validate.type || "string"](validate);
}
